import React from 'react'
import PropTypes from 'prop-types'

import dynamic from 'next/dynamic'
import { useQuery } from '@apollo/client'
import styles from './style.module.scss'

import { HOT_STORIES, TRENDING_NEWS } from '@graphql/home/home.query'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import WidgetCardHeader from '../widgets/widgetHeader'

const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })
const TrendingNewsList = dynamic(() => import('./trendingNewsList'), {
  loading: () => loader
})

const loader = (
  <>
    {Array.from(Array(3)).map((e, i) => {
      return (
        <div className="my-3 d-flex" key={i}>
          <div>
            <Skeleton height={'60px'} width={'96px '} />
          </div>
          <div className="w-100 ps-2">
            <Skeleton height={'40px'} className={'mb-2'} />
            <div height={'14px'} className="d-flex">
              <Skeleton width={'20%'} height={'14px'} className={'me-2'} />
              <Skeleton width={'20%'} height={'14px'} className={'me-3'} />
            </div>
          </div>
        </div>
      )
    })}
  </>
)

function TrendingNewsArticle({ ePlatform = '', isTennis = false }) {
  const { data, loading } = useQuery(TRENDING_NEWS, {
    variables: { input: { nSkip: 0, nLimit: 4 } },
    skip: isTennis
  })

  const { data: seoData } = useQuery(GET_SEO_DATA, {
    variables: { input: { sSlug: 'tennis-news' } },
    skip: !isTennis
  })
  const { data: hotStories, loading: hotStoriesLoading } = useQuery(HOT_STORIES, {
    variables: {
      input: {
        iCategoryId: seoData?.getSeoData?.iId,
        eType: 'n',
        nLimit: 5
      }
    },
    skip: !isTennis
  })

  const dataToMap = isTennis ? hotStories?.listSimpleCategoryArticlesVideosFront?.oArticles?.aResults : data?.getTrendingNews?.aResults

  return (
    <>
      {dataToMap !== 0 && (
        <div className="widget">
          <>
            <WidgetCardHeader headerText={'Featured News'} />
            <div className={styles.trendingList}>
              <TrendingNewsList data={dataToMap} ePlatform={ePlatform} />
            </div>
          </>
          {loading && loader && hotStoriesLoading}
        </div>
      )}
    </>
  )
}
TrendingNewsArticle.propTypes = {
  isSlider: PropTypes.bool,
  ePlatform: PropTypes.string,
  isTennis: PropTypes.bool
}
export default TrendingNewsArticle
